import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { GodotDocsIndexSelector } from "./GodotDocsIndexSelector";
import { GodotDocsVersion } from "./GodotDocsVersion";

export class GodotLinks
{
  static gl = new ElementType( "g-l" );
  static rl = new ElementType( "r-l" );


  static applyOnDocument()
  {
    GodotLinks.gl.forAllInDoc( e => GodotLinks.applyOnElement( e ) );
    GodotLinks.rl.forAllInDoc( e => GodotLinks.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let anchorPath = GodotLinks.getPath( e, e.textContent );
    
    let wrapped = HTMLEditor.wrapWithAnchorHref( e, anchorPath );

    Rokojori.$.resolveRootPaths( wrapped );
    
  }

  static getPath( e:Element, path:string )
  {
    let isRokojori = GodotLinks.rl.is( e );
    return GodotDocsIndexSelector.resolvePathFromName( e.textContent, isRokojori );
  }
}